import { StandardIcon } from '@/components/common/icon';
import { Tooltip, Button } from '@/components/ui';

export function HouseholdCell({
  id,
  onClick,
}: {
  id?: string;
  onClick?: () => void;
}) {
  if (!id) {
    return null;
  }

  return (
    <div className='flex flex-row justify-center'>
      <Tooltip content='View Household'>
        <Button
          isIconOnly
          onPress={onClick}
          variant='flat'
          className='bg-transparent'
        >
          <StandardIcon id='mdi:house-outline' size={20} />
        </Button>
      </Tooltip>
    </div>
  );
}
